import { defineMessages } from "@/i18n";
import en from "./en";

export const inputBarComposerTipsMessages = defineMessages(
  "input-bar-composer-tips",
  en,
);
